import { useQuery } from '@tanstack/react-query';
import { API } from 'aws-amplify';
import React, { Dispatch } from 'react';
import { AdData } from '../types';
import { captureError } from '../utils/capture-error';

// State
type AdState = {
  banners: AdData[];
  footerTiles: AdData[];
};
const initialState: AdState = {
  banners: [],
  footerTiles: [],
};

// Actions
type AdActions = {
  type: 'SET_ADS';
  payload: { banners: AdData[]; footerTiles: AdData[] };
};

const reducer = (state: AdState, action: AdActions) => {
  switch (action.type) {
    case 'SET_ADS': {
      const { banners, footerTiles } = action.payload;
      return { ...state, banners, footerTiles };
    }
    default: {
      return { ...state };
    }
  }
};

export const AdContext = React.createContext(
  {} as {
    state: AdState;
    dispatch: Dispatch<AdActions>;
  },
);

export function AdProvider(props: { children: React.ReactNode }) {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  // Query - Get Ad Content
  const path = '/ads';
  const queryKey = [path];
  useQuery({
    queryKey,
    enabled: !state.banners.length && !state.footerTiles.length,
    queryFn: async () => {
      const response: {
        data: AdData[];
      } = await API.post('DashboardAPI', path, {});
      if (response.data) {
        const banners = response.data.filter(
          (i) => i.AdType === 'Banner' && i.Published,
        );
        const footerTiles = response.data.filter(
          (i) => i.AdType === 'Footer' && i.Published,
        );
        dispatch({ type: 'SET_ADS', payload: { banners, footerTiles } });
      }
      return null;
    },
    onError: (error) => captureError({ data: { error } }),
  });

  return (
    <AdContext.Provider value={{ state, dispatch }}>
      {props.children}
    </AdContext.Provider>
  );
}
